import HorizontalCalendar from 'components/HorizontalCalendar/HorizontalCalendar';

export default HorizontalCalendar;
